import React from "react";
import GoalsModule from "./goalsModule";
import GoalsSagas from "./redux/goalsSagas";
import GoalsReducer from "./redux/goalsReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Goals",
  moduleList: [
    {
      Component: GoalsModule,
      moduleName: "goals",
      saga: GoalsSagas(),
      reducer: GoalsReducer
    }
  ],
  hideConfigurator: true
};

const GoalsPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default GoalsPage;
